import React from 'react';
import { Link } from 'react-router-dom';

const CommunityPage = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-6">Community</h1>
      <p className="text-xl mb-8">
        Join our vibrant community of developers, engineers, and innovators.
        Share knowledge, get support, and collaborate on solutions.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-semibold mb-4 text-gray-900 dark:text-white">Discussion Forums</h2>
          <p className="mb-4 text-gray-600 dark:text-gray-300">
            Engage in technical discussions, share experiences, and get help from the community.
          </p>
          <span className="text-gray-500 dark:text-gray-400 text-sm">
            Coming soon
          </span>
        </div>

        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-semibold mb-4 text-gray-900 dark:text-white">User Groups</h2>
          <p className="mb-4 text-gray-600 dark:text-gray-300">
            Connect with users in your region or industry. Join virtual and in-person meetups.
          </p>
          <span className="text-gray-500 dark:text-gray-400 text-sm">
            Coming soon
          </span>
        </div>

        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-semibold mb-4 text-gray-900 dark:text-white">Developer Hub</h2>
          <p className="mb-4 text-gray-600 dark:text-gray-300">
            Access development resources, sample code, and contribute to open-source projects.
          </p>
          <span className="text-gray-500 dark:text-gray-400 text-sm">
            Coming soon
          </span>
        </div>
      </div>

      <div className="bg-gray-100 p-8 rounded-lg">
        <h2 className="text-2xl font-semibold mb-4">Get Involved</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <h3 className="text-xl font-medium mb-3">Contribute</h3>
            <ul className="space-y-2">
              <li>• Share your knowledge</li>
              <li>• Answer community questions</li>
              <li>• Submit feature requests</li>
              <li>• Report bugs</li>
            </ul>
          </div>
          <div>
            <h3 className="text-xl font-medium mb-3">Benefits</h3>
            <ul className="space-y-2">
              <li>• Learn from experts</li>
              <li>• Network with peers</li>
              <li>• Stay updated on latest features</li>
              <li>• Earn recognition</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommunityPage; 